"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_click_listener_for_attr_1 = __importDefault(require("../../utils/add-click-listener-for-attr"));
(0, add_click_listener_for_attr_1.default)('data-accordion-menu-toggle', function (key) {
    var accordion = document.querySelector("[data-accordion-menu=\"".concat(key, "\"]"));
    var menu = document.querySelector("[data-accordion-menu-toggle=\"".concat(key, "\"]"));
    if (!accordion) {
        return;
    }
    accordion.style.maxHeight = accordion.style.maxHeight ? '' : "".concat(accordion.scrollHeight, "px");
    menu.classList.toggle('active');
});
